export const formatPriceWithEuroMark = (price?: number) =>
  price ? ` ${(price / 100).toFixed(2)} €` : '';
